import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListConceptsQuery, useGetUserQuery, ConceptStatus, ConceptKind, RiskManagementScheme } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Concepts',
  setup: function setup(__props) {
    var _attr$query;
    var _ref = useNuxtApp(),
      $i18n = _ref.$i18n;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var attr = useAttrs();
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var headers = [{
      value: 'id',
      cellClass: 'font-weight-bold'
    }, {
      value: 'labelI18n.en',
      cellClass: 'font-weight-bold'
    }, {
      value: 'labelI18n.de',
      cellClass: 'font-weight-bold'
    }, {
      value: 'description'
    }, {
      value: 'kind'
    }, {
      value: 'status'
    }, {
      value: 'label',
      cellClass: 'font-weight-bold'
    }, {
      value: 'sourceUrl'
    }, {
      value: 'citation'
    }, {
      value: 'isSubmeasure',
      cellClass: 'overflow-auto'
    }, {
      value: 'scheme'
    }, {
      value: 'isMaterial'
    }, {
      value: 'materialityExplanation'
    }, {
      value: 'additionalData.industries',
      cellClass: 'max-w-[200px]'
    }, {
      text: $i18n.t('actions'),
      value: 'actions'
    }].map(function (col) {
      return _objectSpread(_objectSpread({}, col), {}, {
        sortable: col.sortable || false
      });
    }).filter(function (column) {
      var _attr$columns;
      return (_attr$columns = attr.columns) === null || _attr$columns === void 0 ? void 0 : _attr$columns.includes(column.value);
    });
    var esgConcepts = ref(attr.esgConcepts || false);
    var route = useRoute();
    var options = ref({
      page: 1,
      itemsPerPage: 15
    });
    var statusFilters = ref([]);
    var schemeFilters = ref([]);
    var isMaterialFilter = ref([]);
    var isSubmeasureFilter = ref([]);
    var internalFilters = ref({
      text: ((_attr$query = attr.query) === null || _attr$query === void 0 ? void 0 : _attr$query.text) || ''
    });
    var variables = computed(function () {
      var _isMaterialFilter$val, _isSubmeasureFilter$v;
      var queryInput = _objectSpread(_objectSpread(_objectSpread({}, attr.query), internalFilters.value), {}, {
        onlyMeasuresAndActions: true,
        status: statusFilters.value,
        scheme: schemeFilters.value,
        isMaterial: [2, 0].includes((_isMaterialFilter$val = isMaterialFilter.value) === null || _isMaterialFilter$val === void 0 ? void 0 : _isMaterialFilter$val.length) ? null : isMaterialFilter.value[0],
        isSubmeasure: [2, 0].includes((_isSubmeasureFilter$v = isSubmeasureFilter.value) === null || _isSubmeasureFilter$v === void 0 ? void 0 : _isSubmeasureFilter$v.length) ? null : isSubmeasureFilter.value[0]
      });
      return {
        queryInput: queryInput,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListConceptsQuery = useListConceptsQuery(variables),
      result = _useListConceptsQuery.result,
      loading = _useListConceptsQuery.loading,
      refetch = _useListConceptsQuery.refetch;
    var items = computed(function () {
      var _result$value$listCon, _result$value;
      return (_result$value$listCon = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listConcepts) !== null && _result$value$listCon !== void 0 ? _result$value$listCon : [];
    });
    var itemCount = computed(function () {
      var _result$value$countCo, _result$value2;
      return (_result$value$countCo = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countConcepts) !== null && _result$value$countCo !== void 0 ? _result$value$countCo : 0;
    });
    var statusFiltersLength = computed(function () {
      return statusFilters.value && statusFilters.value.length || 0;
    });
    var schemeFiltersLength = computed(function () {
      return schemeFilters.value && schemeFilters.value.length || 0;
    });
    var selected = ref([]);
    var newItem = ref({});
    var deleteDialog = ref(false);
    var deleteItem = function deleteItem() {
      // TODO admin-actions: Delete
    };
    var closeDelete = function closeDelete() {
      deleteDialog.value = false;
    };
    var editDialog = ref({});
    var setEditDialog = function setEditDialog(id, v) {
      editDialog.value = _defineProperty({}, id, v);
    };
    var createDialog = ref(false);
    var dialogType = ref('New Measure');
    var initializeNewItem = function initializeNewItem(isSubmeasure) {
      var baseItem = {
        labelI18n: {},
        descriptionI18n: {},
        materialityExplanationI18n: {},
        citationI18n: {},
        sourceUrl: '',
        status: ConceptStatus.Verified,
        additionalData: '',
        kind: ConceptKind.Company,
        isSubmeasure: isSubmeasure,
        isMaterial: false
      };
      if (isSubmeasure === false) {
        baseItem.scheme = RiskManagementScheme.Implementation;
      }
      return baseItem;
    };
    var openNewMeasureDialog = function openNewMeasureDialog() {
      dialogType.value = 'New Measure';
      newItem.value = initializeNewItem(false);
      createDialog.value = true;
    };
    var openNewActionDialog = function openNewActionDialog() {
      dialogType.value = 'New Action';
      newItem.value = initializeNewItem(true);
      createDialog.value = true;
    };
    return {
      __sfc: true,
      $i18n: $i18n,
      userResult: userResult,
      attr: attr,
      user: user,
      headers: headers,
      esgConcepts: esgConcepts,
      route: route,
      options: options,
      statusFilters: statusFilters,
      schemeFilters: schemeFilters,
      isMaterialFilter: isMaterialFilter,
      isSubmeasureFilter: isSubmeasureFilter,
      internalFilters: internalFilters,
      variables: variables,
      result: result,
      loading: loading,
      refetch: refetch,
      items: items,
      itemCount: itemCount,
      statusFiltersLength: statusFiltersLength,
      schemeFiltersLength: schemeFiltersLength,
      selected: selected,
      newItem: newItem,
      deleteDialog: deleteDialog,
      deleteItem: deleteItem,
      closeDelete: closeDelete,
      editDialog: editDialog,
      setEditDialog: setEditDialog,
      createDialog: createDialog,
      dialogType: dialogType,
      initializeNewItem: initializeNewItem,
      openNewMeasureDialog: openNewMeasureDialog,
      openNewActionDialog: openNewActionDialog,
      ConceptStatus: ConceptStatus,
      RiskManagementScheme: RiskManagementScheme
    };
  }
});